export default "__VITE_ASSET__DpMuZ6XS__"